import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { RouterModule } from '@angular/router';
import { NZ_I18N, es_ES } from 'ng-zorro-antd/i18n';

const customEs = {
  ...es_ES,
  DatePicker: {
    ...es_ES.DatePicker,
    lang: {
      ...es_ES.DatePicker.lang,
      rangeQuarterPlaceholder: ['Inicio trimestre', 'Fin trimestre']
    }
  }
};

// app modules
import { DashboardModule } from './features/dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { HomeComponent } from './layout/home/home.component';

@NgModule({
  declarations: [AppComponent, TopbarComponent, HomeComponent],
  imports: [BrowserModule, DashboardModule, RouterModule, SharedModule],
  providers: [
    ...appConfig.providers,
    { provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: NZ_I18N, useValue: customEs },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
